import React from 'react';
import PropTypes from 'prop-types';
import { StyledTooltip } from './Tooltip.styles';

/**
 * Tooltip - Componente atômico para dicas e informações adicionais
 * 
 * Este componente segue o princípio do Atomic Design como um "átomo".
 * Fornece uma base consistente para tooltips no sistema.
 */
const Tooltip = ({
  title,
  children,
  placement = 'top',
  arrow = true,
  className = '',
  ...props
}) => {
  return (
    <StyledTooltip
      title={title}
      placement={placement}
      arrow={arrow}
      className={`base-tooltip ${className}`}
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};

Tooltip.propTypes = {
  /** Conteúdo do tooltip */
  title: PropTypes.node.isRequired,
  /** Elemento que aciona o tooltip */
  children: PropTypes.node.isRequired,
  /** Posição do tooltip */
  placement: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
    'left-start',
    'left-end',
    'right',
    'right-start',
    'right-end',
  ]),
  /** Se o tooltip deve ter uma seta */
  arrow: PropTypes.bool,
  /** Classes CSS adicionais */
  className: PropTypes.string,
};

export default Tooltip; 